import { ILandingConsoleStore, useLandingConsoleStore } from "src/modules/pe-landing-module/data/store"
import Transform from "../Transform.panel"
import Zoom from "../zoom-form/Zoom"
import ZoomTool from "../zoom-form/ZoomTool"
import { IPanelStore, usePanelStore } from "../../../UIX/store"

/* Protopia Ecosystem component */
export interface ITopPanelProps {
   
}
const TopPanel = (props: ITopPanelProps): JSX.Element => {
    const settings      = useLandingConsoleStore((state:ILandingConsoleStore) => state.settings)
    const isHidePanels: boolean     = usePanelStore((state: IPanelStore) => state.isHidePanels)
    if(!settings.topPanel || !!isHidePanels ) {
        return <></>
    }
    return <div className='landing-top-panel pe-panel-container'>
        <ZoomTool />
        <div className="zoom-panel">
            <Zoom />
        </div> 
        <div className="transform-panel">
            <Transform />
        </div>
    </div>
}
export default TopPanel